// Límite de caracteres del nombre de una cartera en tbl_cartera (issue #916). El backend
// rechaza nombres más largos en registrarcartera / registrarcarteraponderador.
export const MAX_NOMBRE_CARTERA = 15;

/**
 * Compone un nombre de cartera que no supere MAX_NOMBRE_CARTERA recortando la base, de modo
 * que el sufijo ('-G', 'inf', '_DIV'...) se conserve siempre.
 */
export function nombreCarteraConSufijo(base: string | String | null | undefined, sufijo = ''): string {
    const limpio = String(base ?? '').trim();
    return limpio.slice(0, Math.max(0, MAX_NOMBRE_CARTERA - sufijo.length)) + sufijo;
}
